import _ from "lodash";
import {
	_api_updateCartQty,
	_api_deleteCart,
	_api_getCarts,
  _api_getShopToken,
	_api_getCartInfo,
	_api_createCart,
	_api_createCartGroup,
} from "../../api/index.js";
import { ElLoading } from 'element-plus'

const defaultCartData = () => ({
	account_shop_coin: 0,
	carts: [],
	checkout_amount_limit: 0,
	country: 'TW',
	currency: 'TWD',
	currency_point: 0,
	currency_symbol: 'NT$',
	enable_insurance_fees: false,
	free_delivery_amount_limit: 0,
	invoice_type: 'ELECTRONIC',
	logistics: [],
	payments: [],
	promotions: [],
	dataUpdateAt: +new Date(),
	eventID: null,
	loading: true,
});

const defaultProductChooseAssortDialogData = () => ({
	visible: false,
	data: {},
	dataUpdateAt: +new Date(),
})

const defaultCheckoutDialogData = () => ({
	visible: false,
	data: {},
	dataUpdateAt: +new Date(),
});

export const state = () => ({
	storeData: {},
	dealerData: {},
	distributorData: {},
	distributorLevels: [],
	userData: {},
	isSubscribe: 0,
	cartCount: 0,
	cartData: defaultCartData(),
	productChooseAssortDialog: defaultProductChooseAssortDialogData(),
	checkoutDialog: defaultCheckoutDialogData(),
	checkoutLoginDialogVisible: false,
});

const getters = {
	storeData: (state) => state.storeData,
	dealerData: (state) => state.dealerData,
	distributorData: (state) => state.distributorData,
	distributorLevels: (state) => state.distributorLevels,
	userData: (state) => state.userData,
	isSubscribe: (state) => state.isSubscribe,
	cartCount: (state) => state.cartCount,
	cartData: (state) => state.cartData,
	productChooseAssortDialog: (state) => state.productChooseAssortDialog,
	productChooseAssortDialogDataUpdateAt: (state) => state.productChooseAssortDialog.dataUpdateAt,
	checkoutDialog: (state) => state.checkoutDialog,
	checkoutDialogDataUpdateAt: (state) => state.checkoutDialog.dataUpdateAt,
	checkoutLoginDialogVisible: (state) => state.checkoutLoginDialogVisible,
};

export const mutations = {
	setStoreData(state, newStoreData) {
		state.storeData = newStoreData;
	},
	setDealerData(state, newDealerData) {
		state.dealerData = newDealerData;
	},
	setDistributorData(state, content) {
		state.distributorData = content;
	},
	setDistributorLevels(state, content) {
		state.distributorLevels = content;
	},
	setUserData(state, newUserData) {
		state.userData = newUserData;
	},
	setIsSubscribe(state, newIsSubscribe) {
		state.isSubscribe = newIsSubscribe;
	},
	setCartCount(state, newCartCount) {
		state.cartCount = newCartCount;
	},
	setCartData(state, newCartData) {
		state.cartData = {
			...state.cartData,
			...newCartData,
		};
	},
	setProductChooseAssortDialog(state, newProductChooseAssortDialog) {
		state.productChooseAssortDialog = {
			...state.productChooseAssortDialog,
			...newProductChooseAssortDialog,
		};
    console.debug("商品規格", state.productChooseAssortDialog)
	},
	setCheckoutDialog(state, newCheckoutDialog) {
		state.checkoutDialog = {
			...state.checkoutDialog,
			...newCheckoutDialog,
		};
    // console.debug("setCheckoutDialog", newCheckoutDialog)
	},
	resetProductChooseAssortDialog(state) {
		state.productChooseAssortDialog = defaultProductChooseAssortDialogData();
	},
	resetCheckoutDialog(state) {
		state.checkoutDialog = defaultCheckoutDialogData();
	},
	setCheckoutLoginDialogVisible(state, visible) {
		state.checkoutLoginDialogVisible = visible
	}
};

const actions = {
  async getShopToken() {
    // 重新取得購物車token
    const token = Cookies.get("_SHOP_TOKEN_")
    if (!token) {
      await _api_getShopToken()
    }
  },
	async updateCart(context) {
    // 先檢查 _SHOP_TOKEN_
    await context.dispatch('getShopToken')
		return _api_getCartInfo().then((cartData) => {
			let cartCount = 0;
      if (!cartData?.carts) {
        return
      }
      cartData?.carts.forEach((cart, idx) => {
        cartCount += cart.quantity || 0;
        cart.carts_idx = idx
      })
			
			let eventID = cartData?.headers?.["x-request-id"] ? cartData.headers["x-request-id"] : null;
			context.commit('setCartCount', cartCount);
			context.commit('setCartData', { ...cartData, eventID, loading: false });
			return cartCount;
		});
	},
  async changeQty(context, item) {
    context.dispatch("setFullPageLoading", true);
    // 先檢查 _SHOP_TOKEN_
    await context.dispatch('getShopToken')
    try {
      const { cartId, qty } = item
      if (!cartId) {
        return;
      }
      const isBundle = item?.isBundle ? item?.isBundle : false

      // console.debug("changeQty", cartId, qty);
      
      const res = await _api_updateCartQty(cartId, qty, isBundle)
      context.dispatch('loadedCart')
      // console.debug("changeQty res", res);
      return res

    } catch (error) {
      console.error("更新購物車數量失敗: ", item)
      throw error;
    } finally {
      context.dispatch("setFullPageLoading", false);
    }
  },
  async deleteCart(context, cartId) {
    context.dispatch("setFullPageLoading", true);
    // 先檢查 _SHOP_TOKEN_
    await context.dispatch('getShopToken')
    try {
      if (!cartId) {
        return;
      }
      // console.debug("changeQty", cartId, qty);
      
      const res = await _api_deleteCart(cartId)
      context.dispatch('loadedCart')
      // console.debug("changeQty res", res);
      return res

    } catch (error) {
      console.error("刪除購物車失敗: ", item)
      throw error;
    } finally {
      context.dispatch("setFullPageLoading", false);
    }
  },
  async addToCart(context, item) {
    context.dispatch("setFullPageLoading", true);
    // 先檢查 _SHOP_TOKEN_
    await context.dispatch('getShopToken')
    let payload = {};
    
		try {
      const isBundle = item?.isBundle ? item?.isBundle : false
      const data = {
        store_product_id: item?.store_product_id,
        store_assort_id: item?.new_store_assort_id,
        quantity: item?.quantity,
        ptype: item?.ptype,
        isBundle,
      };
      
      let res = null;
      if (item?.event_id) {
        payload = {
          event_id: item?.event_id,
          event_type: item?.event_type,
          items: [data],
        };
        res = await _api_createCartGroup(payload);
      } else {
        payload = data;
        res = await _api_createCart(payload);
      }
      // console.debug("lite/addToCart", payload, res.data)
      context.dispatch('loadedCart')

      return {res, payload}
      
    } catch (error) {
      console.error("加入購物車失敗: ", payload)
      throw error;
    } finally {
      context.dispatch("setFullPageLoading", false);
    }
	},
	async openCheckoutDialog(context, payload) {
    // 先檢查 _SHOP_TOKEN_
    await context.dispatch('getShopToken')
		// 檢查登入
		let { skipLogin } = payload || {};
    // console.debug('skipLogin', skipLogin, context.state.userData?.id)
		if (!skipLogin && !context.state.userData?.id) {
			context.commit('setCheckoutLoginDialogVisible', true);
			return;
		}
		context.dispatch("setFullPageLoading", true);
		context.dispatch('updateCart').then(() => {
			context.commit('setCheckoutDialog', {
				visible: true,
				data: {
					...context.state.cartData,
					login_user: {
						...context.state.userData,
					},
					scrollToTop: true,
					isCartEditing: false,
					isPatchCartIds: [],
				},
				dataUpdateAt: +new Date(),
			});
		}).finally(() => {
			context.dispatch("setFullPageLoading", false);
		});
	},
  loadedCart(context) {
    // 更新購物車，但不滾動到上方
    context.dispatch('updateCart').then(() => {
      context.commit('setCheckoutDialog', {
        data: {
          ...context.state.cartData,
          login_user: {
            ...context.state.userData,
          },
          scrollToTop: false,
          isCartEditing: false,
          isPatchCartIds: [],
        },
        dataUpdateAt: +new Date(),
      });
    })
  },
	setFullPageLoading(context, payload) {
		if (payload) {
			window.ElFullPageLoading = ElLoading.service({
				lock: true,
				background: 'rgba(0, 0, 0, 0.5)',
			});
		} else {
			window.ElFullPageLoading && window.ElFullPageLoading.close();
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};